module.exports = __webpack_public_path__ + "static/media/knob3.05a7357f.png";